import { EComponentVisibility } from '@spinwise/react-component-library/Global';
import styles from './BrandIcon.module.scss';
import classNames from 'classnames';

export enum BrandIconsSizes {
  Custom = 'custom',
  Small = 'small',
  Regular = 'regular',
  Medium = 'medium',
  Large = 'large',
  ExtraSmall = 'extrasmall',
}

export enum BrandIcons {
  Search = 'search.png',
  Mail = 'mail.png',
  Bonus = 'bonus.png',
  Cashback = 'cashback.png',
  Calendar = 'calendar.png',
  Account = 'account.png',
  AccountSad = 'account.png',
  Sof = 'sof.png',
  Password = 'password.png',
  ResponsibleGaming = 'responsible-gaming.png',
  Deposit = 'deposit.png',
  Withdraw = 'withdraw.png',
  BonusExpired = 'bonus-expired.png',
  Pause = 'pause.png',
  Stop = 'stop.png',
  Break = 'break.png',
  Manager = 'manager.png',
  LoyaltyVip = 'loyalty-vip.png',
  BonusVip = 'bonus-vip.png',
  BonusPackMonthly = 'bonus-pack-monthly.png',
  BonusPackMonthlyFlat = 'bonus-pack-monthly-flat.png',
  BonusPackWelcome = 'bonus-pack-welcome.png',
  NewGame = 'new-game.png',
  BonusBirthday = 'bonus-birthday.png',
  Sfs = 'sfs.png',
  Fs = 'fs.png',
  Recharge = 'recharge.png',
  DepositOne = 'deposit-1.png',
  Mystery = 'mystery.png',
  BonusSfs = 'bonus-sfs.png',
  BonusFs = 'bonus-fs.png',
  BonusRecharge = 'bonus-recharge.png',
  BonusDeposit = 'bonus-deposit.png',
  BonusMystery = 'bonus-mystery.png',
  NoBonus = 'bonus-no.png',
  Gift = 'gift.png',
  Support = 'support.png',
  RegisterMarkLight = 'mark-light.png',
  AgeRestrict = 'age-restriction.png',
  AgeRestrictSad = 'age-restriction-sad.png',
  RegisterMark = 'mark.svg',
  Age18 = 'age-18.svg',
  Age21 = 'age-21.svg',
  Age21Light = 'age21-light.png',
  Coins = 'loss-limit.png',
  BestGame = 'best-game.png',
  VipYellow = 'vip-yellow.svg',
  BonusFreespinsDisabled = 'bonus-freespins-disabled.png',
  BonusMysteryDisabled = 'bonus-mystery-disabled.png',
  BonusDepositDisabled = 'bonus-deposit-disabled.png',
  BonusRechargeDisabled = 'bonus-recharge-disabled.png',
  DepositNotification = 'deposit-notification.png',
  DepositDisabled = 'deposit-disabled.png',
  WithdrawDisabled = 'withdraw-disabled.png',
  Limits = 'limits.png',
  Identity = 'confirm-identity.png',
  Notification = 'notification.png',
  Location = 'location.png',
  BonusFreeBet = 'bonus-risk-free-bet.png',
  BonusFreeBetFlat = 'bonus-risk-free-bet-flat.png',
  BonusFreeBetDisabled = 'bonus-risk-free-bet-disabled.png',
  Sport = 'sport-bonus-notification.png',
  MatchBonus = 'match-bonus.png',
  MatchBonusFlat = 'match-bonus-flat.png',
  BonusWheelFspins = 'bonus-fspins.webp',
  BonusWheelGame = 'bonus-game.webp',
  BonusWheelJackpot = 'bonus-jackpot-flat.webp',
  BonusWheelCashback = 'bonus-money-flat.webp',
  BonusWheelMspins = 'bonus-mspins.webp',
  BonusWheelSfs = 'bonus-sfs.webp',
  BonusWheelRmoney = 'bonus-rmoney.webp',
  Favorites = 'favorites.png',
  BonusGame = 'bonus-game.png',
  BonusMoney = 'bonus-money.png',
  BonusWheel = 'bonus-wheel.png',
  LiveGameFreeBet = 'live-game-free-bet.png',
}

export const BonusIconMap = {
  'SuperSpins.png': BrandIcons.BonusSfs,
  'Spins.png': BrandIcons.BonusFs,
  'Special.png': BrandIcons.BonusRecharge,
  'Percent.png': BrandIcons.BonusDeposit,
  'Mystery.png': BrandIcons.BonusMystery,
  'Sport.png': BrandIcons.BonusFreeBet,
  'BonusGame.png': BrandIcons.BonusGame,
  'cashback.png': BrandIcons.BonusMoney,
  'wheel-jackpot.png': BrandIcons.BonusWheelJackpot,
  'wheel-cashback.png': BrandIcons.BonusWheelCashback,
  'wheel-mspins.png': BrandIcons.BonusWheelMspins,
  'wheel-sfs.png': BrandIcons.BonusWheelSfs,
  'wheel-game.png': BrandIcons.BonusWheelGame,
  'Wheel.png': BrandIcons.BonusWheel,
  'live-game-free-bet.png': BrandIcons.LiveGameFreeBet,
  'wheel-fspins.png': BrandIcons.BonusWheelFspins,
  'wheel-rmoney.png': BrandIcons.BonusWheelRmoney,
};

export enum StatusIcons {
  None = '',
  Success = 'success.png',
  Attention = 'attention.png',
  Faild = 'faild.png',
  Pause = 'pause.png',
  Play = 'play.png',
  Plus = 'plus.png',
  Stop = 'stop.png',
  Warning = 'warning.png',
  SuccessV = 'success.png',
  AttentionV = 'verification/attention.png',
  FaildV = 'verification/faild.png',
  PauseV = 'verification/pause.png',
  PlayV = 'verification/play.png',
  PlusV = 'verification/plus.png',
  StopV = 'verification/stop.png',
  WarningV = 'verification/warning.png',
  VerifyV = 'verification/verify.png',
  PendingV = 'verification/pending.png',
  UpdateV = 'verification/update.png',
}

export enum ShapeColors {
  None = '',
  Default = 'default',
  Success = 'success',
  Attention = 'attention',
  Warning = 'warning',
}

export interface IBrandIconProps {
  iconSize: string;
  iconPath: string;
  statusPath?: string;
  statusStroke?: boolean;
  shapeColor?: string;
  visibility?: EComponentVisibility;
  grayscale?: boolean;
  loading?: 'eager' | 'lazy';
}

export const IMAGES_PATH = '/images/big-icons/';
export const IMAGES_STATUS_PATH = `/images/big-icons/status/`;

const BrandIcon = (props: IBrandIconProps) => {
  const {
    iconSize,
    iconPath,
    statusPath = StatusIcons.None,
    statusStroke = false,
    shapeColor = ShapeColors.None,
    visibility = '',
    loading = 'eager',
  } = props;

  return (
    <div className={`d-fl jc-c ai-c ${styles.container} ${styles[`container--${iconSize}`]} ${visibility}`}>
      <div className={`${styles.shape} ${styles[`shape--${shapeColor}`]}`}></div>
      <img
        className={classNames(styles.icon, { [styles.icon__grayscale]: props.grayscale })}
        src={`${IMAGES_PATH}${iconPath}`}
        loading={loading}
        alt=""
      />
      {statusPath !== '' && (
        <>
          {statusStroke && (
            <div className={styles.status_stroke}>
              <svg width="64" height="64" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <circle cx="102.667" cy="102.667" r="25.3333" fill="currentColor"></circle>
                </g>
                <defs>
                  <clipPath>
                    <rect width="128" height="128" fill="currentColor"></rect>
                  </clipPath>
                </defs>
              </svg>
            </div>
          )}
          <img
            className={`${styles.status} ${styles[`status--${iconSize}`]}`}
            src={`${IMAGES_STATUS_PATH}${statusPath}`}
            loading={loading}
            alt=""
          />
        </>
      )}
    </div>
  );
};

export default BrandIcon;
